const de = {
  nav: {
    home: 'Startseite',
    about: 'Über uns',
    solutions: 'Lösungen',
    industries: 'Branchen',
    contact: 'Kontakt',
  },

  home: {
    phases: [
      {
        h1Before: 'Maßgeschneiderte ',
        h1Highlight: 'IT',
        h1After: '-Lösungen',
        h3: 'die mit Ihrem Unternehmen wachsen',
        cols: [
          { border: 'l-blue', lines: ['Digitale', 'Präsenz'] },
          { border: 'l-cyan', lines: ['Anwendungs-', 'entwicklung'] },
          { border: 'l-pink', lines: ['Enterprise-', 'Integration'] },
        ],
      },
      {
        h1Before: 'Unser ',
        h1Highlight: 'Wert',
        h1After: 'versprechen',
        h3: 'die mit Ihrem Unternehmen wachsen',
        cols: [
          { border: 'l-blue', lines: ['Prozess-', 'optimierung'] },
          { border: 'l-cyan', lines: ['Digitale', 'Transformation'] },
          { border: 'l-pink', lines: ['Daten-', 'entscheidungen'] },
        ],
      },
      {
        h1Before: 'Strategische ',
        h1Highlight: 'Unternehmens',
        h1After: 'ausrichtung',
        h3: 'die mit Ihrem Unternehmen wachsen',
        cols: [
          { border: 'l-blue', lines: ['Strategische', 'Klarheit'] },
          { border: 'l-cyan', lines: ['Fachkundige', 'Umsetzung'] },
          { border: 'l-pink', lines: ['Langfristige', 'Partnerschaft'] },
        ],
      },
    ],
  },

  about: {
    slides: [
      {
        tag: 'Über uns',
        accent: 'var(--violet)',
        titleBefore: 'Über ',
        titleHighlight: 'uns',
        subtitle: 'Gegründet 2018 mit Sitz in Goslar, Deutschland — mit Entwicklungsteams in Deutschland und Indien.',
        body: 'Entwickelt für KMU und soziale Initiativen, nutzen wir Technologie als Katalysator für nachhaltiges Wachstum — und überbrücken die Lücke zwischen großen Ideen und den digitalen Lösungen, die sie verwirklichen.',
        features: [
          { label: 'Gegründet in Goslar, Deutschland — 2018' },
          { label: 'Teams in Deutschland & Indien' },
          { label: 'Für KMU & Soziale Initiativen' },
        ],
        quoteBefore: 'Wir schließen die digitale Umsetzungslücke durch Proxy Product Ownership und übersetzen komplexe Geschäftsanforderungen in zuverlässige, skalierbare und leistungsstarke digitale Lösungen.',
        quoteAuthor: 'Strategische Ausrichtung',
      },
      {
        tag: 'Über uns',
        accent: 'var(--cyan)',
        titleBefore: 'Unsere ',
        titleHighlight: 'Vision',
        subtitle: 'KMU durch digitale Transformation und Innovation stärken.',
        body: 'Bei 7elemente sehen wir eine Zukunft, in der kleine und mittelständische Unternehmen ihr volles Potenzial entfalten, indem sie digitale Fähigkeiten mit strategischer Klarheit verbinden. Unser Ziel ist es, KMU zu befähigen, mit maximaler Kapazität zu agieren.',
        features: [
          { label: 'Inspirieren' },
          { label: 'Innovieren' },
          { label: 'Impakt schaffen' },
        ],
        quoteBefore: 'Die nächste Generation von Marktführern wird nicht durch Größe definiert — sondern dadurch, wie gut sie Technologie einsetzen.',
        quoteAuthor: 'Unsere Vision',
      },
      {
        tag: 'Über uns',
        accent: 'var(--highlight)',
        titleBefore: 'Unsere ',
        titleHighlight: 'Mission',
        subtitle: 'Gemeinsam skalierbare Lösungen entwickeln.',
        body: 'Wir entwickeln gemeinsam digitale Lösungen, die mit unseren Kunden wachsen — skalierend mit ihrer Kapazität, ausgerichtet auf ihre Ambitionen und verankert in langfristigem Wert. Durch durchdachtes Design und strategische Partnerschaft schaffen wir nachhaltigen Mehrwert.',
        features: [
          { label: 'Strategische Klarheit' },
          { label: 'Fachkundige Umsetzung' },
          { label: 'Vertrauensvoller Partner' },
        ],
        quoteBefore: 'Sie konzentrieren sich auf Ihre Geschäftsziele — wir sind Ihr IT-Partner.',
        quoteAuthor: 'Unsere Mission',
      },
    ],
  },

  solutions: {
    slides: [
      {
        tag: 'Lösung',
        accent: 'var(--violet)',
        video: 'digexp',
        titleBefore: 'Digitale ',
        titleHighlight: 'Präsenz',
        subtitle: 'Ihre Online-Präsenz ist nicht nur eine Website — sie ist Ihr digitaler Handschlag.',
        body: 'Wir gestalten nahtlose digitale Erlebnisse, die Design, Technologie und Leistung vereinen. Von visuell beeindruckenden Websites bis hin zu leistungsoptimierten Plattformen helfen wir Ihnen, Sichtbarkeit zu gewinnen, Engagement zu fördern und mit Zielstrebigkeit zu wachsen.',
        features: [
          { label: 'Responsives Webdesign' },
          { label: 'SEO & Performance' },
          { label: 'Digitale Transformation' },
        ],
        quoteBefore: 'Ihre Website ist Ihr bester Vertriebsmitarbeiter — rund um die Uhr erreichbar, für jeden, überall.',
        quoteAuthor: 'Digital First',
      },
      {
        tag: 'Lösung',
        accent: 'var(--cyan)',
        video: 'appeng',
        titleBefore: 'Anwendungs-',
        titleHighlight: 'entwicklung',
        subtitle: 'Von Benutzeroberflächen bis hin zu Enterprise-Backend-Systemen — wir entwickeln alles.',
        body: 'Von Startups bis zu wachsenden Produkten und der Modernisierung von Legacy-Systemen verwandeln wir Ideen in leistungsstarke digitale Produkte — mit durchdachtem Design und skalierbarer Technologie.',
        features: [
          { label: 'Individuelle Webanwendungen' },
          { label: 'Mobile App-Entwicklung' },
          { label: 'Workflow-Automatisierung' },
        ],
        quoteBefore: 'Gute Software dreht sich nicht ums Code-Schreiben — es geht darum, die richtigen Probleme auf einfachste Weise zu lösen.',
        quoteAuthor: 'Entwicklungsphilosophie',
      },
      {
        tag: 'Lösung',
        accent: 'var(--highlight)',
        video: 'entint',
        titleBefore: 'Enterprise-',
        titleHighlight: 'Intelligenz',
        subtitle: 'Von Strategie bis Cloud, von Daten bis Prozessen — wir helfen Unternehmen zu wachsen.',
        body: 'Bei 7element helfen wir Handels- und Fertigungsunternehmen, Abläufe zu optimieren, digitale und physische Erlebnisse zu vereinen und mit Zuversicht zu skalieren. Von vernetztem eCommerce bis zu ERP- und PIM-Integration.',
        features: [
          { label: 'PIM-Lösungen' },
          { label: 'Cloud-Infrastruktur' },
          { label: 'Systemintegration' },
        ],
        quoteBefore: 'Integration ist keine technische Herausforderung — sie ist eine strategische. Vernetzte Systeme schaffen vernetzte Organisationen.',
        quoteAuthor: 'Enterprise-Strategie',
      },
    ],
  },

  industries: {
    slides: [
      {
        tag: 'Branche',
        accent: 'var(--violet)',
        video: 'manufacturing',
        title: 'Handel & Fertigung',
        subtitle: 'Digitalisierung von Handelsprozessen und Modernisierung von Fertigungsabläufen.',
        body: 'Bei 7element helfen wir Handels- und Fertigungsunternehmen, Abläufe zu optimieren, digitale und physische Erlebnisse zu vereinen und mit Zuversicht zu skalieren. Von vernetztem eCommerce bis zu ERP- und PIM-Integration.',
        features: [
          { label: 'Produktinformationsmanagement (PIM)' },
          { label: 'E-Commerce & Online-Präsenz' },
          { label: 'Betrieb & Lieferkettenintegration' },
        ],
        quoteBefore: 'Getrennte Systeme schaffen getrennte Erlebnisse. Wir bringen alles zusammen — intelligent, nahtlos und in großem Maßstab.',
        quoteAuthor: 'Handel & Fertigung',
      },
      {
        tag: 'Branche',
        accent: 'var(--cyan)',
        video: 'education',
        title: 'Bildung & Training',
        subtitle: 'Lernen durch digitale Innovation stärken.',
        body: 'Im sich wandelnden Bildungsbereich verbessert die digitale Transformation das Lernen, optimiert die Verwaltung und erweitert den Zugang. Wir helfen Institutionen, personalisierte, skalierbare und ansprechende Lernerfahrungen zu liefern.',
        features: [
          { label: 'E-Learning-Plattformentwicklung' },
          { label: 'Inhalts- & Kursverwaltung' },
          { label: 'EdTech-Anwendungsentwicklung' },
        ],
        quoteBefore: 'Bildung entwickelt sich weiter, und so sollten auch ihre Werkzeuge. Die Nutzung der digitalen Transformation ist keine Option — sie ist eine Notwendigkeit für zukunftsorientiertes Lernen.',
        quoteAuthor: 'Bildung & Training',
      },
      {
        tag: 'Branche',
        accent: 'var(--highlight)',
        video: 'dna',
        title: 'Gesundheit & Wellness',
        subtitle: 'Sichere, vernetzte und menschenzentrierte digitale Gesundheitslösungen.',
        body: 'Die digitale Transformation verändert das Gesundheitswesen durch verbesserte Patientenversorgung, optimierte Abläufe und Compliance-Sicherstellung. Wir entwickeln sichere, skalierbare Systeme für personalisierte Versorgungserfahrungen.',
        features: [
          { label: 'Patientenorientierte Webanwendungen' },
          { label: 'DSGVO-konforme Datenverwaltung' },
          { label: 'Buchungs- & Workflow-Automatisierung' },
        ],
        quoteBefore: 'Im Gesundheitswesen steht hinter jedem Datenpunkt ein Leben. Eine nahtlose, sichere und zugängliche Informationsversorgung ist nicht nur eine technische Notwendigkeit — sie ist eine moralische Pflicht.',
        quoteAuthor: 'Gesundheit & Wellness',
      },
    ],
  },

  contact: {
    navContact: 'Kontakt',
    navImpression: 'Impressum',
    tag: 'Kontakt aufnehmen',
    heading: 'Kontakt',
    headingHighlight: '',
    intro: 'Ob Sie von Grund auf neu beginnen oder skalieren möchten — wir freuen uns, von Ihren Zielen zu hören. Kontaktieren Sie uns, und einer unserer Experten wird sich innerhalb von 24 Stunden bei Ihnen melden.',
    addressLabel: 'Adresse',
    emailLabel: 'E-Mail',
    phoneLabel: 'Telefon',
    form: {
      namePlaceholder: 'Ihr Name',
      emailPlaceholder: 'ihre@email.com',
      companyPlaceholder: 'Ihr Unternehmensname',
      messagePlaceholder: 'Erzählen Sie uns von Ihrem Projekt...',
      nameLabel: 'Name',
      emailLabel: 'E-Mail',
      companyLabel: 'Unternehmen',
      messageLabel: 'Nachricht',
      submit: 'Nachricht senden',
      sending: 'Wird gesendet…',
    },
    successHeading: 'Nachricht gesendet!',
    successBody: 'Wir melden uns innerhalb von 24 Stunden.',
    errorMsg: 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut oder schreiben Sie uns direkt.',
    impression: {
      tag: 'Rechtliches',
      titleBefore: '',
      titleHighlight: 'Impressum',
      subtitle: '7Elemente IT-Solutions UG (haftungsbeschränkt)',
      body: 'Angaben gemäß § 5 TMG. Diese Website wird betrieben von 7Elemente IT-Solutions UG. Alle Inhalte unterliegen dem deutschen Urheberrecht.',
      features: [
        { label: 'Bahnhofstraße 11, 38642 Goslar, Deutschland' },
        { label: 'E-Mail: info@7Elemente.com' },
        { label: 'Telefon: +49 5321 39 49 49 6' },
        { label: 'Register: Amtsgericht Braunschweig' },
      ],
      quoteBefore: 'Transparenz ist nicht nur eine rechtliche Pflicht — sie spiegelt wider, wie wir Geschäfte machen.',
      quoteAuthor: 'Impressum',
    },
  },

  mitra: {
    slides: [
      {
        letter: 'M',
        tag: 'Unsere Werte',
        titleBefore: '',
        titleHighlight: 'Meisterschaft',
        subtitle: '15+ Jahre Enterprise-IT-Exzellenz.',
        body: 'Wir bringen tiefes Fachwissen in SAP, Microsoft Dynamics, Cloud-Infrastruktur und moderner Webentwicklung mit — erworben durch reale Enterprise-Projekte, nicht durch Theorie.',
        features: [
          { label: 'Enterprise-Architektur' },
          { label: 'Domänenübergreifende Expertise' },
          { label: 'Bewährte Lieferung' },
        ],
        accent: 'var(--violet)',
        quote: 'Exzellenz ist keine Fähigkeit — sie ist eine Gewohnheit, die über Jahre des Lösens schwieriger Probleme entsteht.',
      },
      {
        letter: 'I',
        tag: 'Unsere Werte',
        titleBefore: '',
        titleHighlight: 'Integrität',
        subtitle: 'Transparente Lieferung, jeden Schritt des Weges.',
        body: 'Wir glauben an ehrliche Kommunikation, realistische Zeitpläne und keine versteckten Kosten. Unsere Kunden wissen immer, wo ihr Projekt steht.',
        features: [
          { label: 'Transparente Preisgestaltung' },
          { label: 'Ehrliche Zeitpläne' },
          { label: 'Klare Kommunikation' },
        ],
        accent: 'var(--cyan)',
        quote: 'Das Fundament jeder großartigen Partnerschaft ist Vertrauen — und Vertrauen wird durch Transparenz aufgebaut.',
      },
      {
        letter: 'T',
        tag: 'Unsere Werte',
        titleBefore: '',
        titleHighlight: 'Talent',
        subtitle: 'Ein ausgewähltes Netzwerk von Experten.',
        body: 'Wir wählen Spezialisten aus unserem Netzwerk erfahrener Ingenieure, Designer und Strategen aus — und stellen das richtige Team für jede einzigartige Herausforderung zusammen.',
        features: [
          { label: 'Nur Senior-Netzwerk' },
          { label: 'Domänenspezialisten' },
          { label: 'Agile Teams' },
        ],
        accent: 'var(--highlight)',
        quote: 'Großartige Produkte werden nicht von großartigen Unternehmen gebaut — sie werden von großartigen Menschen gebaut.',
      },
      {
        letter: 'R',
        tag: 'Unsere Werte',
        titleBefore: '',
        titleHighlight: 'Zuverlässigkeit',
        subtitle: 'Pünktlich, im Budget — jedes Mal.',
        body: 'Wir setzen realistische Erwartungen und erfüllen sie. Unser strukturierter Projektmanagement-Ansatz gewährleistet gleichbleibende Qualität vom Kickoff bis zum Launch.',
        features: [
          { label: 'Meilensteingetriebene Lieferung' },
          { label: 'Qualitätssicherung' },
          { label: 'Support nach dem Launch' },
        ],
        accent: 'var(--violet)',
        quote: 'Zuverlässigkeit bedeutet nicht, perfekt zu sein — es bedeutet, verlässlich zu sein, wenn es darauf ankommt.',
      },
      {
        letter: 'A',
        tag: 'Unsere Werte',
        titleBefore: '',
        titleHighlight: 'Anpassungsfähigkeit',
        subtitle: 'Agil, zukunftssicher und immer im Wandel.',
        body: 'Technologie verändert sich schnell. Wir bleiben an der Spitze — durch neue Tools, Frameworks und Methoden, die Ihre Lösungen langfristig wettbewerbsfähig halten.',
        features: [
          { label: 'Agile Methodik' },
          { label: 'Zukunftssichere Architektur' },
          { label: 'Kontinuierliche Innovation' },
        ],
        accent: 'var(--cyan)',
        quote: 'Die Unternehmen, die gedeihen, sind nicht die stärksten — sie sind die, die am schnellsten auf Veränderungen reagieren.',
      },
    ],
  },
};

export default de;
